import { Injectable, Injector } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { BaseService } from '../shared/services/base.service';
import { Page } from '../models/page.model';
import { CustoAdicionalTipo } from '../models/custo-adicional-tipo.model';

@Injectable({
    providedIn: 'root'
})
export class CustoAdicionalTipoService extends BaseService<CustoAdicionalTipo> {

    constructor(protected injector: Injector) {
        super(`${environment.API_PRICE}/custoadicionaltipo`, injector);
    }

    getAll(): Observable<Page<CustoAdicionalTipo>> {
        return this.http.get<Page<CustoAdicionalTipo>>(`${environment.API_PRICE}/custoadicionaltipo/getAll`);
    }

    getAllAtivas(): Observable<Page<CustoAdicionalTipo>> {
        return this.http.get<Page<CustoAdicionalTipo>>(`${environment.API_PRICE}/custoadicionaltipo/getAllAtivas`);
    }

    getEntityById(id: number): Observable<Page<CustoAdicionalTipo>> {
        return this.http.get<Page<CustoAdicionalTipo>>(`${environment.API_PRICE}/custoadicionaltipo/getById/${id}`);
    }

    create(entity: CustoAdicionalTipo): Observable<CustoAdicionalTipo> {
        return this.http.post<CustoAdicionalTipo>(`${environment.API_PRICE}/custoadicionaltipo/create`, entity);
    }

    update(entity: CustoAdicionalTipo): Observable<CustoAdicionalTipo> {
        return this.http.put<CustoAdicionalTipo>(`${environment.API_PRICE}/custoadicionaltipo/update`, entity);
    }
}